const defaultTitle = 'Chat | Gecko';
const switchTimeout = 1500;
let additionalTitle = null;

const rotateTitle = () => {
  setTimeout(() => {
    if (additionalTitle) {
      if (document.title === defaultTitle) {
        document.title = additionalTitle;
      } else {
        document.title = defaultTitle;
      }
      rotateTitle();
    }
  }, switchTimeout);
};

const clear = () => {
  additionalTitle = null;
  document.title = defaultTitle;
  const faviconElement32 = document.querySelector(
    'link[rel="icon"][sizes="32x32"]'
  );
  faviconElement32.href = './favicons/favicon-32x32.png';
  const faviconElement16 = document.querySelector(
    'link[rel="icon"][sizes="16x16"]'
  );
  faviconElement16.href = './favicons/favicon-16x16.png';
};
window.onfocus = clear;

const set = (title) => {
  additionalTitle = title;
  document.title = additionalTitle;
  const faviconElement32 = document.querySelector(
    'link[rel="icon"][sizes="32x32"]'
  );
  faviconElement32.href = './favicons/favicon-32x32-alert.png';
  const faviconElement16 = document.querySelector(
    'link[rel="icon"][sizes="16x16"]'
  );
  faviconElement16.href = './favicons/favicon-16x16-alert.png';
  rotateTitle();
};

export default { set, clear };
export { set, clear };
